import { noView } from 'aurelia-framework';
import * as DOMPurify from "dompurify";

@noView()
export class HtmlSanitizeValueConverter {

    toView(value) {
        if (typeof value == "string") {
            return DOMPurify.sanitize(value);
        }
        return value;
    }

    fromView(value) {
        return value;
    }
}